
export default () => ({
    status: 'authenticating',
    user: null,
    idToken: null,
    refreshToken: null,
    id: null,
    idPerfil: null,
    name: null
})